"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=(r=>(r.long="long",r.short="short",r))(t||{}),e=(r=>(r.left="left",r.right="right",r))(e||{});exports.TogglePlacement=e;exports.ToggleWidth=t;
